import Icon from '../Icon';
import { IconSpecificProps } from '../Icon.types';

const IconQuadStar = ({ className, titleAccess }: IconSpecificProps) => (
  <Icon className={className} titleAccess={titleAccess} viewBox="0 0 24 24" fill="none">
    <path
      id="vector"
      d="M11.9984 2.40039L13.9299 7.42223C14.2006 8.12613 14.336 8.47808 14.5465 8.77413C14.7331 9.03651 14.9623 9.26575 15.2247 9.45231C15.5207 9.66282 15.8727 9.79818 16.5766 10.0689L21.5984 12.0004L16.5766 13.9319C15.8727 14.2026 15.5207 14.338 15.2247 14.5485C14.9623 14.735 14.7331 14.9643 14.5465 15.2267C14.336 15.5227 14.2006 15.8746 13.9299 16.5785L11.9984 21.6004L10.067 16.5785C9.79623 15.8746 9.66086 15.5227 9.45036 15.2267C9.26379 14.9643 9.03455 14.735 8.77217 14.5485C8.47613 14.338 8.12418 14.2026 7.42028 13.9319L2.39844 12.0004L7.42028 10.0689C8.12418 9.79818 8.47613 9.66282 8.77217 9.45231C9.03455 9.26575 9.26379 9.03651 9.45036 8.77413C9.66086 8.47808 9.79623 8.12613 10.067 7.42223L11.9984 2.40039Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default IconQuadStar;
